import React from 'react'
import { IcoCog, IcoComentarios, IcoDados, IcoEmpresa, IcoEnvelope, IcoGrupos, IcoList, IcoListAlt, IcoLogOut, IcoPriceTag, IcoTag, IcoUpgrade, IcoUsers, IcoMeusDashboards, IcoPdca } from "../components"
import { IcoRedes } from "../components/icon/custom/icoredes"
import { IcoProdutos } from "../components/icon/custom/icoprodutos"
import { IcoPlanos } from "../components/icon/custom/icoplanos"
import { IcoPrincipaisAssuntos } from "../components/icon/custom/icoprincipaisassuntos"
import { IcoSwot } from "../components/icon/custom/icoswot"

export const menuItensHeader = (permissoes, nls) => {
  return [

    ...(permissoes?.VerFazerUpgrade ? [
      {
        id: "AgendarDemonstracao",
        label: nls.menus.agendarDemo,
        go: "https://calendly.com/bruno-yellowtokens/30min",
        target: "_blank",                 // abrir em nova aba
        rel: "noopener noreferrer",       // segurança
        external: true,                   // (opcional) indique ao seu renderer que é link externo
        icon: ""                          // sem ícone
      },
    ] : []),


    ...permissoes?.VerFazerUpgrade ?[
      { 
        id: "VerFazerUpgrade", 
        label: nls.menus.fazerUpgrade, 
        go: "/accountupgrade", 
        icon: <IcoUpgrade/>
      },
    ] : [],
    { 
      id: "visualizarProjeto", 
      label: nls.menus.meusprojetos, 
      go: "/myprojects", 
      icon: <IcoListAlt/> 
    },

    //{ 
    //  id: "ConfigurarProjeto", 
    //  label: nls.menus.configurar, 
    //  go: "/meusprojetos/novo/configurar", 
    //  icon: '' 
    //},


    //////OLD DAVI
    // ...e?.creditoProjetos?[{ 
    //   id: "CriarProjeto", 
    //   label: nls.menus.criar, 
    //   go: "/meusprojetos", 
    //   icon: '' 
    // }]:[],
    //FIM OLD DAVI


    //{ 
    //  id: "CriarProjeto", 
    //  label: nls.menus.criar, 
    //  go: "/meusprojetos", 
    //  icon: '' 
    //},


    { 
      id: "ComprarProjeto", 
      label: nls.menus.lojadeprojetos, 
      go: "/projects", 
      icon: <IcoTag/> 
    },
  ]
}
  
  
export const menuItens = ({id, projeto,nls}) => {
  return [
    
    { 
      id: "ComentariosNovo", 
      label: "Feedbacks", 
      go: `/myprojects/${id}/feedbacks`,
      icon: <IcoComentarios /> 
    },
    {
      id: "PrincipaisAssuntos",
      label: nls.menusv1.principaisassuntos,
      icon: <IcoPrincipaisAssuntos />,
      sub: [
        {
          id: "IndicadoresEmpresas",
          label: nls.menusv1.sobreempresas,
          go: `/myprojects/${id}/companyindicators`,
        },
        ...(projeto?.temMenuEstabelecimento
          ? [
              {
                id: "Indicadores",
                label: nls.menusv1.sobreestabelecimentos,
                go: `/myprojects/${id}/storeindicators`,
              },
            ]
          : []),
          ...(projeto?.temMenuProduto
            ? [
                {
                  id: "Indicadoresprodutos",
                  label: nls.menusv1.sobreprodutos,
                  go: `/myprojects/${id}/productindicators`,
                },
              ]
            : []),
      ],
    },
    { 
      id: "AnaliseSwotUnificada", 
      label: nls.menusv1.analiseswot, 
      go: `/myprojects/${id}/swotanalysis`,
      icon: <IcoSwot /> 
    },

    { 
      id: "Benchmark", 
      label: "Benchmark", 
      go: `/myprojects/${id}/benchmark`,
      icon: <IcoDados /> 
    },

    /* REMOVIDO DEPOIS QUE CRIAMOS PDCA
    { 
      id: "planos", 
      label: nls.menusv1.planosdeacao, 
      icon: <IcoPlanos />,
      sub: [
        { 
          id: "Plano7Dias", 
          label: nls.menusv1.planosemanal, 
          go: `/myprojects/${id}/pl7`,
        },
        { 
          id: "Plano30Dias", 
          label: nls.menusv1.planomensal, 
          go: `/myprojects/${id}/pl30`,
        } 
      ]
    },
    */

    { 
      id: "redessociais", 
      label: nls.menusv1.redesociais, 
      icon: <IcoRedes />,
      sub: [
        { 
          id: "CSATREDES", 
          label: "CSAT", 
          go: `/myprojects/${id}/csatsocialclient`,
        },
        { 
          id: "NPSREDES", 
          label: "NPS", 
          go: `/myprojects/${id}/npssocialclient`,
        },
        { 
          id: "CSATConcorrentesRedes", 
          label: nls.menusv1.csatcomparacaoconcorrentes, 
          go: `/myprojects/${id}/csatsocialcompetitors`,
        },
        { 
          id: "NPSConcorrentesRedes", 
          label: nls.menusv1.npscomparacaoconcorrentes, 
          go: `/myprojects/${id}/npssocialcompetitors`,
        },
        { 
          id: "INDICADORESREDES", 
          label: nls.menusv1.indicadores, 
          go: `/myprojects/${id}/socialindicators`,
        }

      ]
    },

    ...projeto?.temMenuEmpresa ? [{ 
      id: "empresas", 
      label: nls.menusv1.empresas, 
      icon: <IcoEmpresa />,
      sub: [
        { 
          id: "CSAT", 
          label: "CSAT", 
          go: `/myprojects/${id}/csat`,
        },
        { 
          id: "NPS", 
          label: "NPS", 
          go: `/myprojects/${id}/nps`,
        },
        { 
          id: "CSATConcorrentes", 
          label: nls.menusv1.csatcomparacaoconcorrentes, 
          go: `/myprojects/${id}/csatcompetitors`,
        },
        { 
          id: "NPSConcorrentes", 
          label: nls.menusv1.npscomparacaoconcorrentes, 
          go: `/myprojects/${id}/npscompetitors`,
        }
      ]
    }] : [],

    

    ...projeto?.temMenuEstabelecimento ? [{ 
      id: "lojas", 
      label: nls.menusv1.estabelecimentos, 
      icon: <IcoGrupos />,
      sub: [
        { 
          id: "Resumodosgrupos", 
          label: nls.menusv1.resumodosgrupos, 
          go: `/myprojects/${id}/storegroupsummary`,
        },
        { 
          id: "RankingClienteCSAT", 
          label: "CSAT", 
          go: `/myprojects/${id}/csatstores`,
        },
        { 
          id: "RankingClienteNPS", 
          label: "NPS", 
          go: `/myprojects/${id}/npsstores`,
        },
        { 
          id: "RankingCSAT", 
          label: nls.menusv1.csatcomparacaoconcorrentes, 
          go: `/myprojects/${id}/csatstorescompetitors`,
        },
        { 
          id: "RankingNPS", 
          label: nls.menusv1.npscomparacaoconcorrentes, 
          go: `/myprojects/${id}/npsstorescompetitors`,
        }
        
      ]
    }] : [],

    ...projeto?.temMenuProduto ? [{ 
      id: "Produtos", 
      label: nls.menusv1.produtos, 
      icon: <IcoProdutos />,
      sub: [
        { 
          id: "Resumodosgruposprodutos", 
          label: nls.menusv1.resumodosgrupos, 
          go: `/myprojects/${id}/productgroupsummary`,
        },
        { 
          id: "CSATPRODUTOS", 
          label: "CSAT", 
          go: `/myprojects/${id}/csatproductclient`,
        },
        { 
          id: "NPSPRODUTOS", 
          label: "NPS", 
          go: `/myprojects/${id}/npsproductclient`,
        },
        { 
          id: "RankingClienteCSAT", 
          label: nls.menusv1.csatcomparacaoconcorrentes, 
          go: `/myprojects/${id}/csatproductcompetitor`,
        },
        { 
          id: "RankingClienteNPS", 
          label: nls.menusv1.npscomparacaoconcorrentes, 
          go: `/myprojects/${id}/npsproductcompetitor`,
        }
      ]
    }] : [],

    //{ 
    //  id: "Comentarios", 
    //  label: "Comentários", 
    //  go: `/meusprojetos/${id}/comentarios`,
    //  icon: <IcoComentarios /> 
    //},
    
  ]
}

export const menuUserInfo = (e, nls) => {
  return [
    { 
      id: "Dadoscadastro", 
      label: nls.menus.dadosCadastro, 
      action: "modalMeusDadosCadastro", 
      icon: <IcoCog /> 
    },
    ...e?.VerGerenciarUsuarios?[{ 
      id: "Gerenciarusuários", 
      label: nls.menus.gerenciarUsuarios,  
      go: "/users", 
      icon: <IcoUsers /> 
    }]:[],
    ...e?.VerHistoricoFaturas?[{ 
      id: "Históricodefaturas", 
      label: nls.menus.historicoFaturas,
      icon: <IcoList />
    }]:[],
    ...e?.VerMinhasAssinaturas?[{ 
      id: "MinhasAssinaturas", 
      label: nls.menus.minhasAssinaturas, 
      go: "/mysubscriptions", 
      icon: <IcoPriceTag /> 
    }]:[],

    { 
      id: "MeusDashboards", 
      label: nls.menus.meusDashboards || "Meus Dashboards", 
      action: "listar", // ✅ MESMA ACTION USADA NO BOTÃO
      icon: <IcoMeusDashboards /> // ✅ USE UM ÍCONE ADEQUADO
    },


        {
      id: "WhatsAppConnection",
      label: nls.menus.whatsappConnection,
      action: "whatsappConnection",
      icon: <IcoEnvelope />
    },
    
    { 
      id: "IntegracaoUsuarioPdca", 
      label: nls.menus.integracaoUsuarioPdca, 
      action: "integracaoUsuarioPdca", 
      icon: <IcoPdca /> 
    },

    { 
      id: "Suporte", 
      label: nls.menus.suporte, 
      action: "contatoSuporteModal", 
      icon: <IcoEnvelope /> 
    },

    { 
      id: "Sair", 
      label: nls.menus.sair, 
      icon: <IcoLogOut /> 
    },
  ]
}